function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import { useState, useMemo } from 'react';
import { Button, Flex, HelpText, Link, List, SrOnly, Text, useId } from '@applyboard/crystal-ui';
import { ChevronDownOutlineIcon, ChevronUpOutlineIcon, DeleteFillIcon, DocumentCheckOutlineIcon, EditOutlineIcon } from '@applyboard/ui-icons';
import { decideShouldShowField, getComponentPage, isEmptyValue, isFieldComponent, isFileInfo } from "./DynamicForm.utils";
import { useTranslation } from '@applyboard/ui-utils';
import { assert } from "../../utils/assert";
import { Mustache } from "../../utils/mustache";
import get from 'lodash/get';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
export function DynamicFormPreview(_ref) {
  var AdditionalFileInformation = _ref.AdditionalFileInformation,
    files = _ref.files,
    _ref$filePreviewType = _ref.filePreviewType,
    filePreviewType = _ref$filePreviewType === void 0 ? 'link' : _ref$filePreviewType,
    formData = _ref.formData,
    formMetadata = _ref.formMetadata,
    formDefinition = _ref.formDefinition,
    onEditClick = _ref.onEditClick,
    onDeleteFileClick = _ref.onDeleteFileClick,
    showIncompleteFields = _ref.showIncompleteFields;
  var visibleComponents = useMemo(function () {
    if (!formData || !formDefinition) {
      return [];
    }
    return formDefinition.components.filter(function (component) {
      return decideShouldShowField(component, formData) && (showIncompleteFields || !isEmptyValue(formData[component.key]));
    });
  }, [formDefinition, formData, showIncompleteFields]);
  if (!formData || !(visibleComponents !== null && visibleComponents !== void 0 && visibleComponents.length)) {
    return null;
  }
  return _jsx(Flex, {
    direction: "column",
    gap: 4,
    children: visibleComponents.map(function (component, index) {
      return _jsx(ReadonlyField, {
        index: index,
        component: component,
        formData: formData,
        formMetadata: formMetadata,
        files: files,
        filePreviewType: filePreviewType,
        AdditionalFileInformation: AdditionalFileInformation,
        onEditClick: onEditClick,
        onDeleteFileClick: onDeleteFileClick,
        showIncompleteFields: showIncompleteFields
      }, component.key);
    })
  });
}
export function ReadonlyField(_ref2) {
  var files = _ref2.files,
    component = _ref2.component,
    formData = _ref2.formData,
    formMetadata = _ref2.formMetadata,
    index = _ref2.index,
    _ref2$filePreviewType = _ref2.filePreviewType,
    filePreviewType = _ref2$filePreviewType === void 0 ? 'link' : _ref2$filePreviewType,
    AdditionalFileInformation = _ref2.AdditionalFileInformation,
    onEditClick = _ref2.onEditClick,
    onDeleteFileClick = _ref2.onDeleteFileClick,
    showIncompleteFields = _ref2.showIncompleteFields;
  var labelId = useId();
  var value = formData[component.key];
  if (!showIncompleteFields && isEmptyValue(value) || !isFieldComponent(component)) {
    return null;
  }
  return _jsxs(Flex, {
    direction: "column",
    gap: filePreviewType === 'link' ? 2 : 4,
    role: "region",
    "aria-labelledby": labelId,
    children: [_jsx(Text, {
      id: labelId,
      variant: "labelL",
      children: _jsxs(Flex, {
        gap: 2,
        children: [_jsxs(Flex.Item, {
          basis: 6,
          grow: 1,
          children: [index + 1, "."]
        }), _jsx(Flex.Item, {
          basis: "100%",
          children: component.label
        })]
      })
    }), _jsx(ReadonlyFieldValue, {
      AdditionalFileInformation: AdditionalFileInformation,
      component: component,
      files: files,
      filePreviewType: filePreviewType,
      formData: formData,
      formMetadata: formMetadata,
      onDeleteFileClick: onDeleteFileClick,
      onEditClick: onEditClick,
      showIncompleteFields: showIncompleteFields
    })]
  });
}
function ReadonlyFieldValue(_ref3) {
  var AdditionalFileInformation = _ref3.AdditionalFileInformation,
    component = _ref3.component,
    files = _ref3.files,
    _ref3$filePreviewType = _ref3.filePreviewType,
    filePreviewType = _ref3$filePreviewType === void 0 ? 'link' : _ref3$filePreviewType,
    formData = _ref3.formData,
    formMetadata = _ref3.formMetadata,
    onDeleteFileClick = _ref3.onDeleteFileClick,
    onEditClick = _ref3.onEditClick,
    showIncompleteFields = _ref3.showIncompleteFields;
  var value = formData[component.key];
  if (showIncompleteFields && isEmptyValue(value)) {
    return _jsx(Flex, {
      pl: 6,
      children: "--"
    });
  }
  return _jsx(_Fragment, {
    children: component.type === 'file' && Array.isArray(value) ? _jsx(_Fragment, {
      children: _jsx("div", {
        style: {
          marginTop: onEditClick ? '0px' : '-12px'
        },
        children: value.map(function (value, index) {
          var file = getFileByFieldValue({
            value: value,
            files: files
          });
          if (!file) {
            return _jsxs(Flex, {
              gap: 3,
              align: "center",
              pl: 6,
              children: [_jsx("div", {
                style: {
                  minHeight: '48px',
                  width: filePreviewType === 'link' ? '88px' : '96px',
                  display: 'flex',
                  alignItems: 'center'
                },
                children: _jsx(Text, {
                  variant: "labelM",
                  children: "Attachment\xA0"
                })
              }), _jsx(HelpText, {
                showIcon: true,
                children: "This file has been removed and is no longer available."
              })]
            }, index);
          }
          return _jsx(FilePreview, {
            file: file,
            filePreviewType: filePreviewType,
            AdditionalFileInformation: AdditionalFileInformation,
            onEditClick: onEditClick ? function () {
              onEditClick === null || onEditClick === void 0 ? void 0 : onEditClick(getComponentPage(component));
            } : undefined,
            onDeleteFileClick: onDeleteFileClick
          }, index);
        })
      })
    }) : _jsxs(Flex, {
      gap: 3,
      align: "start",
      pl: 6,
      children: [_jsx(Flex, {
        pt: 3,
        children: _jsx(ReadableValue, {
          component: component,
          value: value,
          formMetadata: formMetadata
        })
      }), onEditClick && _jsx(Button, {
        leadIcon: EditOutlineIcon,
        emphasis: "transparent",
        intent: "primary",
        onClick: function onClick() {
          onEditClick(getComponentPage(component));
        },
        "aria-label": "Edit response"
      })]
    })
  });
}
function FilePreview(_ref4) {
  var file = _ref4.file,
    filePreviewType = _ref4.filePreviewType,
    AdditionalFileInformation = _ref4.AdditionalFileInformation,
    onEditClick = _ref4.onEditClick,
    onDeleteFileClick = _ref4.onDeleteFileClick;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isCollapsed = _useState2[0],
    setIsCollapsed = _useState2[1];
  var previewId = useId();
  if (!file) {
    return null;
  }
  return _jsxs(Flex, {
    direction: "column",
    gap: 2,
    grow: 1,
    pl: 6,
    children: [_jsxs(Flex, {
      gap: 3,
      align: "center",
      children: [filePreviewType === 'link' ? _jsx(_Fragment, {
        children: file.downloadLink ? _jsxs(Link, {
          leadIcon: DocumentCheckOutlineIcon,
          href: file.downloadLink,
          mode: "override_user_choice_and_open_in_new_tab",
          variant: "standalone",
          children: [file.name, _jsx(SrOnly, {
            children: "(Click to download)"
          })]
        }) : _jsxs(Flex, {
          align: "center",
          gap: 2,
          py: 3,
          children: [_jsx(DocumentCheckOutlineIcon, {}), _jsx(Text, {
            children: file.name
          })]
        })
      }) : _jsxs(Flex, {
        gap: 2,
        align: "center",
        children: [_jsx(DocumentCheckOutlineIcon, {
          intent: "secondary"
        }), file.name, _jsx(Button, {
          intent: "primary",
          emphasis: "transparent",
          size: "sm",
          trailIcon: isCollapsed ? ChevronDownOutlineIcon : ChevronUpOutlineIcon,
          onClick: function onClick() {
            return setIsCollapsed(!isCollapsed);
          },
          "aria-expanded": !isCollapsed,
          "aria-controls": previewId,
          children: isCollapsed ? 'Show file preview' : 'Hide file preview'
        })]
      }), onEditClick && _jsx(Button, {
        leadIcon: EditOutlineIcon,
        emphasis: "transparent",
        intent: "primary",
        onClick: onEditClick,
        "aria-label": "Edit response"
      }), onDeleteFileClick && _jsx(Button, {
        leadIcon: DeleteFillIcon,
        emphasis: "transparent",
        intent: "negative",
        onClick: function onClick() {
          return onDeleteFileClick(file.id);
        },
        "aria-label": "Delete file"
      })]
    }), !isCollapsed && _jsx(Flex, {
      id: previewId,
      pl: 28,
      children: file.contentType === 'application/pdf' ?
      // Setting the height to 100% viewport height minus the navbar (plus some padding)
      _jsx("div", {
        style: {
          height: 'calc(100vh - 92px)',
          width: '100%',
          overflowY: 'auto'
        },
        children: _jsx("iframe", {
          title: file.name,
          src: file.downloadLink,
          width: "100%",
          height: "100%"
        })
      }) : _jsx("img", {
        src: file.downloadLink,
        alt: file.name,
        style: {
          maxWidth: '100%'
        }
      })
    }), AdditionalFileInformation && _jsx(Flex, {
      children: _jsx(Flex.Item, {
        basis: "100%",
        children: _jsx(AdditionalFileInformation, {
          file: file
        })
      })
    })]
  });
}
export function ReadableValue(_ref5) {
  var value = _ref5.value,
    component = _ref5.component,
    formFileInformation = _ref5.formFileInformation,
    formMetadata = _ref5.formMetadata;
  var _useTranslation = useTranslation('DynamicForm'),
    t = _useTranslation.t;
  if (component.type === 'radio') {
    var _component$values$fin;
    return _jsx(Text, {
      children: ((_component$values$fin = component.values.find(function (item) {
        return item.value === value;
      })) === null || _component$values$fin === void 0 ? void 0 : _component$values$fin.label) || ''
    });
  }
  if (component.type === 'select') {
    var _component$data$value;
    if ('template' in component) {
      var _formMetadata$selectD;
      // TOOD: more granular error messages here
      var selectedItem = formMetadata === null || formMetadata === void 0 ? void 0 : (_formMetadata$selectD = formMetadata.selectData) === null || _formMetadata$selectD === void 0 ? void 0 : _formMetadata$selectD[component.key];
      assert(get(selectedItem, component.valueProperty) === value, 'selected item does not match value');
      var label = Mustache.render(component.template, {
        item: selectedItem
      });
      return _jsx(Text, {
        children: label
      });
    }
    return _jsx(Text, {
      children: ((_component$data$value = component.data.values.find(function (item) {
        return item.value === value;
      })) === null || _component$data$value === void 0 ? void 0 : _component$data$value.label) || ''
    });
  }
  if (component.type === 'file' && Array.isArray(value)) {
    return _jsx(Flex, {
      direction: "column",
      gap: 2,
      children: value.map(function (file, index) {
        if (typeof file === 'string' || isFileInfo(file)) {
          assert(formFileInformation, 'formFileInformation is required when using type=file');
          return _jsxs(Flex, {
            gap: 1,
            children: [_jsx(DocumentCheckOutlineIcon, {}), _jsx(Text, {
              variant: "bodyM",
              children: typeof file === 'string' ? formFileInformation[file] : file.file.name
            })]
          }, index);
        }
        return null;
      })
    });
  }
  if (component.type === 'checkbox') {
    if (value) {
      return _jsx(Text, {
        children: t('checkedCheckboxText')
      });
    }
    return null;
  }
  if (component.type === 'selectboxes' && Array.isArray(value)) {
    return _jsx(List, {
      children: value.map(function (value, idx) {
        var _component$values$fin2;
        return _jsx(List.Item, {
          children: ((_component$values$fin2 = component.values.find(function (item) {
            return item.value === value;
          })) === null || _component$values$fin2 === void 0 ? void 0 : _component$values$fin2.label) || ''
        }, idx);
      })
    });
  }
  if (typeof value === 'string' || typeof value === 'number') {
    return _jsx(Text, {
      children: value
    });
  }
  return _jsx(Text, {
    children: _jsx(_Fragment, {})
  });
}
function getFileByFieldValue(_ref6) {
  var value = _ref6.value,
    files = _ref6.files;
  var file = files === null || files === void 0 ? void 0 : files.find(function (file) {
    if (typeof value === 'string') {
      return file.id === value;
    }
    if (isFileInfo(value)) {
      return file.id === value.id;
    }
    return false;
  });
  return isFileInfo(file) ? {
    id: file.id,
    name: file.file.name,
    validationResults: []
  } : file;
}